import React, { Fragment } from 'react';
import styled from 'styled-components';
import I10n from '../../features/i10n';
import LicenseSubGroup from './license_sub_group';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const Title = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 20px;

  @media (max-width: 800px) {
    display: none;
  }
`;

const Subtitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #000000;
  margin-bottom: 20px;
  @media (max-width: 800px) {
    margin-bottom: 10px;
  }
`;

class LicenseDisplayGroup extends React.Component {

    render() {
      const {
        licenseDisplayGroup,
        isSaving,
        onAddSoftwareLicencesRequested,
        softwareSelection,
        knowMoreLinksMap
      } = this.props;

      return (
        <Container id={`plc-display-groups-${licenseDisplayGroup.displayGroupKey}`}>
          <Title>{I10n.getOrDefault(`screen.licence_selector.display_group.name.${licenseDisplayGroup.labelKey}`, licenseDisplayGroup.displayGroupName)}</Title>
          {licenseDisplayGroup.displayGroupDescription && <Subtitle>{I10n.getOrDefault(`screen.licence_selector.display_group.description.${licenseDisplayGroup.labelKey}`, licenseDisplayGroup.displayGroupDescription)}</Subtitle>}
          {licenseDisplayGroup.subGroups.map((licenseSubGroup, idx) => {
            return (
              <Fragment key={idx}>
              <LicenseSubGroup
                licenseSubGroup={licenseSubGroup}
                isSaving={isSaving}
                onAddSoftwareLicencesRequested={onAddSoftwareLicencesRequested}
                softwareSelection={softwareSelection}
                knowMoreLinksMap={knowMoreLinksMap}
              />
            </Fragment>
            );
          })}
        </Container>
      );
    }
  }

  export default LicenseDisplayGroup;
